/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Error\NotFoundPage\NotFound.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday June 6th 2023 4:38:55 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

export default function NotFound() {
    return (
        <p>Page not found</p>
    );
}
